const routes = [
    //后台投顾列表
    {
        path: '/lecturer/list',
        component: function () {
            return import('@/components/admin/team/LecturerList')
        }
    },
    {
        path: '/lecturer/detail',
        component: function () {
            return import('@/components/admin/team/LecturerDetail')
        }
    },
]

export default routes